import { Fragment, h } from 'preact'
import { signal } from '@preact/signals'
import { getElcoConf } from '../../js/modules/getElcoConf.js'
import { SG1Logs } from '../../js/modules/logs.js'
import { addScript } from '../../js/modules/utilities.js'

export const metaDataState = signal('')

var isMetatadaDone = false

export const Metadata = ({ SEO, partners, technical, sections, idzoneVector }) => {
   try {
      // Head sections
      addHeadSections(metaDataState)

      // Medatada
      if (isMetatadaDone === false) {
         isMetatadaDone = true

         // Project specific config
         addSpecificConfig(technical, idzoneVector)

         // data-islog sur le body
         addDataIsLog(technical.isUserLogged)

         // Body sections
         addBodySections(technical, sections)

         // dataLayer
         addDatalayer(getPageId(technical.pageId), technical.isUserLogged, technical.deviceType, technical.idTracking, technical.experimentVariant)

         // Elements communs
         addElco(technical)

         // Publicité (adGateway)
         addAdgateway(technical, partners)

         // Sentry
         addSentry(technical)
      }
   } catch (error) {
      console.error('metadata orchestrator', error)
      SG1Logs.incLog('Err_CORCH')
   }

   return (
      <Fragment>
         <title>{SEO.title}</title>
         <meta name="description" content={SEO.description} />
         <meta name="robots" content="index, follow" />
         <link href={SEO.canonicalURL} rel="canonical" />
         {partners.facebooksiteverif && <meta name="facebook-domain-verification" content={partners.facebooksiteverif} />}
         {partners.googlesiteverif && <meta name="google-site-verification" content={partners.googlesiteverif} />}
         <script type="application/ld+json">{SEO.jsonLD}</script>
         {technical.featureFlags.pf_cyclope && <script src="https://artifactory.si.francetelecom.fr/mfy-ftaccueilv-generic/cyclope/cyclope.user.js" />}
      </Fragment>
   )
}

const getPageId = (refZ) => {
   const listPageId = {
      hp: ['hp', 'hp-nl', 'hp-mob', 'hp-mob-nl'],
      'hp-regulier': ['regulier', 'regulier-nl', 'regulier-mob', 'regulier-mob-nl'],
      'hp-occasionnel': ['occas', 'occas-nl', 'occas-mob', 'occas-mob-nl'],
      'hp-prospect': ['prospect-nl', 'prospect-mob-nl'],
      'vitrine-boutique': ['boutique-nl', 'boutique-mob-nl'],
      'vitrine-boutique-client': ['boutique', 'boutique-mob'],
      'n1-tv-prospect': ['divert-prospect-nl', 'divert-prospect-mob-nl', 'divert-prospect', 'divert-prospect-mob'],
      'n1-tv': ['divert-client-nl', 'divert-client-mob-nl', 'divert-client', 'divert-client-mob'],
   }

   for (let key in listPageId) {
      if (listPageId[key].includes(refZ)) {
         return key
      }
   }
}

const addDatalayer = (pageId, isUserLogged, deviceType, idTracking, experimentVariant) => {
   switch (pageId) {
      case 'hp':
         window.o_data = {
            domaine: 'Portail',
            titre_page: 'hp',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break
      case 'vitrine-boutique':
      case 'vitrine-boutique-client':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'hp_boutique',
            type_page: 'hp',
            univers_affichage: 'global',
         }
         break

      case 'n1-tv-prospect':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_prospect-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
      case 'n1-tv':
         window.o_data = {
            domaine: 'Shop',
            titre_page: 'cremaillere_divertissement_client-tv',
            type_page: 'cremaillere',
            univers_affichage: 'tv',
         }
         break
   }
   window.o_data.id_tracking = idTracking
   window.o_data.segment = 'RES'
   window.o_data.sous_univers = 'global'
   window.o_data.canal = deviceType === 'mobile' ? 'Mobile Web' : 'Web'

   deviceType === 'mobile' ? (window.o_data.titre_page += '_webapp') : ''
   isUserLogged === true ? (window.o_data.titre_page += '_logue') : (window.o_data.titre_page += '_non_logue')

   // Abtests
   // ajoute le variant choisi par l'API pour l'abtest qui a été choisi
   if (experimentVariant && experimentVariant.variant) {
      window.o_data.experiment = experimentVariant.variant
   }
}

const addHeadSections = (metaDataState) => {
   //HeadSections
   let headSections = []
   if (metaDataState.value !== '' && metaDataState.value['headSections'] !== undefined) {
      headSections = metaDataState.value['headSections'].headSections
      if (headSections.length > 0) {
         // Création du header masqué qui contiendra les sections
         const headerElement = document.createElement('header')
         headerElement.id = 'headSections'
         document.body.insertAdjacentElement('afterbegin', headerElement)
         // Ajout des sections dans le header masqué
         for (const section of headSections) {
            const headSectionElement = document.createElement('section')
            headSectionElement.id = section
            headerElement.appendChild(headSectionElement)
         }
      }
   }
}

const addBodySections = (technical, sections) => {
   // Page sections et H1
   const mainElement = document.getElementById('sg1-sections')
   if (mainElement !== null) {
      // H1 pour les HP
      if (getPageId(technical.pageId).startsWith('hp')) {
         const h1Element = document.createElement('h1')
         h1Element.textContent = 'Accueil du site Orange'
         h1Element.classList.add('sr-only')
         mainElement.appendChild(h1Element)
      }
      // sections
      for (const section of sections) {
         const sectionElement = document.createElement('section')
         sectionElement.id = section
         mainElement.appendChild(sectionElement)
      }
   }
}

const addSpecificConfig = (technical, idzoneVector) => {
   // idzone
   window.o_idzone = idzoneVector

   // Body classes & ID
   document.body.id = getPageId(technical.pageId)
   if (technical.isUserLogged === true) document.body.classList.add('is-logged')
   document.body.classList.add(`is-${technical.deviceType}`) // is-mobile, is-desktop ou is-tablet

   // Page Testid
   const testid = `${technical.pageId}`
   document.body.setAttribute('data-testid', testid)
}

const addDataIsLog = (isUserLogged) => {
   document.body.setAttribute('data-islogged', isUserLogged === true ? 'true' : 'false')
}

const addElco = (technical) => {
   const initPDB = () => {
      const pdbConfig = {
         prefix: 'adv',
         watchedAttributes: ['canal', 'cappingdata'],
         pixelURL: technical.adviseCappingURL,
         method: 'POST',
         plugin: 'adviseCapping',
      }
      try {
         if (window.dataStoreHP.SSEstatus === 'disconnected') {
            o_pdb.init(pdbConfig)
         } else {
            document.addEventListener('sseEndOfTransmition', () => {
               o_pdb.init(pdbConfig)
            })
         }
      } catch (error) {
         console.error('Pdb capping error')
         SG1Logs.logError(`initPDB : Pdb capping error : ${error.message}`)
      }
   }

   const initElco = () => {
      // WORKAROUND : Trigger le DOMContentLoaded pour déclencher le header des elcos
      window.document.dispatchEvent(
         new Event('DOMContentLoaded', {
            bubbles: true,
            cancelable: true,
         })
      )

      if (typeof head !== 'undefined') {
         if (technical.userconsent?.c1 === true && technical.userconsent?.c2 === true && !technical.featureFlags.ff_disable_pdb) {
            // il faut avoir les elco pour executer le capping advise
            addScript('', '', 'https://c.woopic.com/tools/pdb.min.js', initPDB)
         }

         o_footer()
      }
   }

   const addElcoConf = (refZ, appEnv) => {
      const listConfNameRefZ = {
         hp: ['hp', 'hp-mob'],
         'hp-nl': ['hp-nl', 'hp-mob-nl'],
         boutique: ['boutique', 'boutique-nl'],
         'boutique-mob': ['boutique-mob', 'boutique-mob-nl'],
         divert: ['divert-prospect', 'divert-prospect-nl', 'divert-client', 'divert-client-nl'],
         'divert-mob': ['divert-prospect-mob', 'divert-prospect-mob-nl', 'divert-client-mob', 'divert-client-mob-nl'],
      }
      //methode qui retourne la clé de config qui contient la refZ et affecte la confelco correspondante à o_confCommon
      for (let key in listConfNameRefZ) {
         if (listConfNameRefZ[key].includes(refZ)) {
            window.o_confCommon = getElcoConf(key)
            break
         } else {
            window.o_confCommon = getElcoConf('hp')
         }
      }
      window.o_confCommon.typeEnv = appEnv === 'dev' || appEnv === 'staging' || appEnv === 'preprod' ? 'rec' : 'prod'
      window.o_confCommon.tracking.refz.page = refZ
   }

   if (!technical.featureFlags.pf_disable_partners) {
      addElcoConf(technical.pageId, technical.appEnv)
      addScript('', '', 'https://c.woopic.com/libs/common/o_load_responsive.js', initElco)
   }
}

const addAdgateway = (technical, partners) => {
   if (partners.adGatewayURL !== '' && !technical.featureFlags.pf_disable_partners) {
      if (technical.featureFlags.ff_6569_adgateway_before_eot) {
         addScript('', '', partners.adGatewayURL, null, false, 'script-pub')
      } else {
         // On attend que tous les id pub soient posés pour déclencher le tag adgateway
         document.addEventListener('sseEndOfTransmition', () => {
            addScript('', '', partners.adGatewayURL, null, false, 'script-pub')
         })
      }
   }
}

const addSentry = (technical) => {
   if (technical.featureFlags.ff_sentry) {
      let sampleRate = 0.01
      if (technical.appEnv === 'dev' || technical.appEnv === 'staging') {
         sampleRate = 1.0 // 100% en dev et staging
      }
      let sentryTag = document.createElement('script')
      sentryTag.src = 'https://browser.sentry-cdn.com/10.8.0/bundle.min.js'
      sentryTag.integrity = 'sha384-OeXjkPMDAnxIgoEIBDnXWKhce+ctYZHJjn+VcfoEzUIV/YPFgf5sPIMT6Fr68nfq'
      sentryTag.crossOrigin = 'anonymous'
      sentryTag.onload = () => {
         Sentry.init({
            dsn: 'https://30c8b7449a3d3dccbcfcf31a9635a42f@sentry.si.fr.intraorange/5',
            sampleRate: sampleRate,
            environment: technical.appEnv,
         })
      }
      document.head.appendChild(sentryTag)
   }
}
